<template lang="pug">
v-app
  v-content
    v-layout(column, align-center, justify-center, style='height: 100%')
      .number 404
      .text Deze pagina bestaat niet.

      v-btn(color='primary', :to='{ name: "home" }') Home

</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
@import 'src/styles/variables';

.number {
  font-size: 80px;
  font-weight: bold;
  color: #666;
}

.text {
  font-size: 18px;
  padding: $g;
  margin: $g;
  color: $dark;
}

</style>
